
import { mapState, mapActions } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: 'CustomIllustrate',
components: {
XHeader,
},
data() {
return {}
},
computed: {
...mapState({
customOrder: ({ order }) => order.customOrder,
}),
contractImages() {
if (this.customOrder.contractImages) {
return this.customOrder.contractImages
}
return []
},
},
methods: {
...mapActions(['fetchCustomOrder']),
},
created() {
const { customOrderId } = this.$route.params
const request = {
customOrderId,
}
this.fetchCustomOrder(request)
},
}



// WEBPACK FOOTER //
// ./client/components/Custom/CustomIllustrate.vue